/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

export const environment = {
  production: true,
  envName: 'stage2'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts